import type { Plate } from './plate.interface';
import type { PlatePosition } from './plate-position.interface';

export interface cv_PlateType {
    Abbreviation: string;
    C_PlateType_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    Columns: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    Plate: Plate[];
    PlatePosition: PlatePosition[];
    PlateType: string;
    Rows: number;
    SortOrder: number | null;
    Version: number;
}
